const ADJECTIVES = [
  'Shadow',
  'Toxic',
  'Swift',
  'Silent',
  'Savage',
  'Neon',
  'Wild',
  'Arctic',
  'Crimson',
  'Frozen',
  'Storm',
  'Vivid',
  'Rogue',
  'Void',
  'Hyper',
];

const NOUNS = [
  'Raptor',
  'Reaper',
  'Viper',
  'Hawk',
  'Wolf',
  'Sniper',
  'Raider',
  'Knight',
  'Fox',
  'Drift',
  'Bullet',
  'Spark',
  'Edge',
  'Fang',
  'Titan',
];

const FEED_VERBS = [
  'eliminated',
  'cranked',
  'boxed',
  'clapped',
  'sent back to lobby',
  'fried',
  'beam lasered',
  'one-pumped',
];

export const BOT_RADIO_QUIPS = [
  'Rotations?',
  'Need mats',
  'Third party incoming!',
  'One cracked on me',
  'Pushing height',
  'Storm pushing us',
  'Heal up!',
  'Watch the flank',
  'Box fight!',
  'Reloading',
] as const;

const BOT_ELIM_FLAVOR = [
  'was sent back to lobby',
  'got boxed',
  'got third-partied',
  'ran out of mats',
  'got caught in storm',
  'got beam lasered',
] as const;

function pick<T>(arr: readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)]!;
}

/** Fortnite-style name: AdjectiveNoun + 2–3 digits, e.g. ShadowRaptor42 */
export function randomElimName(): string {
  const adj = pick(ADJECTIVES);
  const noun = pick(NOUNS);
  const digits = Math.random() < 0.5 ? 2 : 3;
  const max = 10 ** digits;
  const n = Math.floor(Math.random() * max)
    .toString()
    .padStart(digits, '0');
  return `${adj}${noun}${n}`;
}

export function randomFeedVerb(): string {
  return pick(FEED_VERBS);
}

export function randomBotRadioQuip(): string {
  return pick(BOT_RADIO_QUIPS);
}

export function randomBotElimFlavor(victim: string, killer?: string): string {
  if (killer && killer !== victim) {
    return `${killer} ${randomFeedVerb()} ${victim}`;
  }
  return `${victim} ${pick(BOT_ELIM_FLAVOR)}`;
}
